import React from 'react';
import { TrendingDown } from '@mui/icons-material';

export const getAlertTypeIcon = (type) => {
  switch (type) {
    case 'no_stock_moving':
      return <TrendingDown sx={{ fontSize: '12px' }} />;
    default:
      return <TrendingDown sx={{ fontSize: '12px' }} />; // Default to no sales icon since only one type exists
  }
};

export const getAlertTypeText = (type, t) => {
  switch (type) {
    case 'no_stock_moving':
      return t ? t('noStockMoving') : 'No Stock Moving';
    default:
      // Format snake_case to readable text as fallback
      return type ? type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'No Stock Moving';
  }
};